module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "hres7de-group"
    }
  }, [_c('div', {
    staticClass: "evaluation-header clearfix cursor-pointer border-top-color-skin",
    on: {
      "click": function($event) {
        _vm.toggleGroup()
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-8 clear-padding"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-3 clear-padding"
  }, [_vm._v(_vm._s(_vm.labels['HRES7DEP2']['30']) + " " + _vm._s(_vm.dataGroup.numgrup))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-7 clear-padding evaluation-title"
  }, [_vm._v(_vm._s(_vm.dataGroup.desc_numgrup))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 clear-padding evaluation-score"
  }, [_vm._v(_vm._s(_vm.calResultScore(_vm.dataGroup)) + "/" + _vm._s(_vm.calTotalScore(_vm.dataGroup)))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groupDisp),
      expression: "groupDisp"
    }],
    staticClass: "evaluation-body"
  }, [_c('div', {
    staticClass: "evaluation-section clearfix"
  }, [_vm._l((_vm.dataGroup.numitem), function(item, index) {
    return [_c('hres7de-item', {
      key: index,
      attrs: {
        "dataGroup": _vm.dataGroup,
        "item": item,
        "choices": _vm.choices,
        "name": _vm.name
      }
    })]
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f930e6e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres7de/group.vue
// module id = 3809
// module chunks = 1